<template>
    <div class="recordList-wrap">

      <Modal
        class="recordList "
        width="800"
        :closable="false"
        footer-hide

        :mask-closable="false"
        v-model="parameter">

          <div slot="header">
              <p>诊疗选择</p>
          </div>
        <p class="desc-record-p">请选择操作的互联网医院诊次</p>
        <Table border ref="selection" size="small" highlight-row 	@on-current-change="currentChange"	:columns="columnsRecordList" :data="dataRecordList"></Table>
        <div  class="record-footer">
            <Button type="primary" @click="handlerRecordOrder">确定</Button>
            <Button @click="handlerCancle">取消</Button>
        </div>
      </Modal>
    </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
export default {
  name: 'recordModel',
  props: {
    parameter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // modalRecordList: false,
      dataRecordList: [],
      userInfo: {
        currentid: '',
        userInfoHtml: ''
      },
      // currentid: '',
      columnsRecordList: [
        {
          title: '选择',
          key: 'no',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('div', {
                props: {

                },
                ref: 'radioTable',
                class: 'radio-table',
                style: {
                  'width': '0.5rem',
                  'height': '0.5rem',
                  'text-align': 'center',
                  'margin': ' 0 auto',
                  'border-radius': '50%',
                  'border': '1px solid #e2e2e2',
                  'cursor': 'pointer',
                  'background': this.userInfo.orderId === params.row.orderId ? '#2ba8f4' : '#ffff'
                },
                on: {
                  click: (e) => {
                    // console.log

                  }
                }
              })
            ])
          }
        },
        {
          title: '患者姓名',
          key: 'name'
        }, {
          title: '年龄',
          key: 'age'
        }, {
          title: '性别',
          key: 'sex'
        }, {
          title: '接诊时间',
          key: 'consultationTime'
        }, {
          title: '症状描述',
          key: 'symptomDesc'
        } ]
    }
  },

  created: function () {
    // this.getRecordOrder()
  },
  watch:{
    parameter: function (val) {
     this.getRecordOrder()
    },
  },
  methods: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest'
    }),
    // 获取取药方式
    getRecordOrder () {
      api.queryDiagnosisRecordList({
        data: {
          params: {
            userId: this.$store.state.prvateConsultation.headerUserRest.userId
          }
        }
      })
        .then(res => {
          this.dataRecordList = res.data.list
        })
    },
    // 发送去取药方式
    handlerRecordOrder (e) {
      this.$emit('handlermodalRecordList', {
        e: e,
        type: 'takeDrug',
        orderId: this.userInfo.orderId,
        userInfoHtml: this.userInfo.userInfoHtml
      })
    },
    handlerCancle () {
      this.$emit('handlermodalCancel', {
        parameter: this.parameter
      })
    },
    currentChange (currentRow, oldCurrentRow) {
      this.userInfo.orderId = currentRow.orderId
      this.userInfo.userInfoHtml = [
        '<p>',
        '<span>就诊人：' + currentRow.name + '</span>',
        '</p>',
        '<p>',
        '<span>年龄：' + currentRow.age + '</span><span>性别：' + currentRow.sex + '</span>',
        '</p>',
        '<p>',
        '<span>接诊时间：' + currentRow.consultationTime + '</span>',
        '</p>',
        '<p class="messageTakeDrug-btn">请点击此处<br>选择您便捷的取药方式</p>',
        '</p>'
      ].join('')
    }
  }
}

</script>

<style>
.recordList .ivu-modal-header{
  background: #72beff;
  color: #fff;

}
.recordList .ivu-modal-header p{
  color: #fff !important;
}
.desc-record-p{
  font-size: 0.3rem;
  margin-bottom: 0.2rem;
}
.record-footer{
  text-align: center;
}
.record-footer button{
  margin:0 3rem;
  width: 3rem;
}
.record-footer .ivu-btn-primary{
  background: #72beff;
  border-color: #72beff;
}
.ivu-table-row-highlight .radio-table{
  background:#2ba8f4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/diagnosisRecordList/index.vue